import { withAuthentication } from 'HOC/IsUserAuth';
import ChangePassword from 'containers/Auth/changePassword/changePassword';
import { NotFound } from 'containers/NotFound';
import { PasswordEdit } from 'containers/settings/PasswordEdit/PasswordEdit';
import { DeleteAccount } from 'containers/settings/DeleteAccount/deleteAccount';
import {
  About,
  Contact,
  ForgotPassword,
  Home,
  HowItsWork,
  Questions,
  Register,
  Login,
  Requests,
  Settings,
  //Tours,
  VerifyPassword,
  Welcome,
  PrivacyPolicy,
  CookiePolicy,
  TermsAndConditions,
  Suggestion,
  TourSuggestion,
} from 'containers';
import { OfferItem } from 'containers/Requests/fragments/Offers/OfferItem';
import { RequestQuestions } from 'containers/Requests/fragments/RequestsCountries/fragments/RequestQuestions';
import { RequestItem } from 'containers/Requests/fragments/RequestsCountries/fragments/RequestsOffer/OfferItem';
import { RequestsOffer } from 'containers/Requests/fragments/RequestsCountries/fragments/RequestsOffer';
import { ToursById } from 'containers/Tours/toursById/toursById';
import { ROUTES } from 'utils/routeNames';
import { v4 as uuid } from 'uuid';
import {
  AdminHome,
  AdminQuestions,
  SignIn,
  AdminRequests,
  AdminOffer,
  AdminPackages,
  HotOffers,
  AdminProfile,
} from 'admin/containers';

export const publicRoutes = [
  {
    id: uuid(),
    name: 'Welcome',
    component: <Welcome />,
    path: ROUTES.INDEX,
  },
  {
    id: uuid(),
    name: 'PrivacyPolicy',
    component: <PrivacyPolicy />,
    path: ROUTES.PRIVACY_POLICY,
  },
  {
    id: uuid(),
    name: 'CookiePolicy',
    component: <CookiePolicy />,
    path: ROUTES.COOKIE_POLICY,
  },
  {
    id: uuid(),
    name: 'TermsAndConditions',
    component: <TermsAndConditions />,
    path: ROUTES.TERMS_CONDITIONS,
  },
  {
    id: uuid(),
    name: 'Login',
    component: withAuthentication(Login),
    path: ROUTES.LOGIN,
  },
  {
    id: uuid(),
    name: 'Register',
    component: withAuthentication(Register),
    path: ROUTES.REGISTER,
  },
  {
    id: uuid(),
    name: 'ForgotPassword',
    component: withAuthentication(ForgotPassword),
    path: ROUTES.FORGOT_PASSWORD,
  },
  {
    id: uuid(),
    name: 'VerifyPassword',
    component: withAuthentication(VerifyPassword),
    path: ROUTES.VERIFY_EMAIL,
  },
  {
    id: uuid(),
    name: 'ChangePassword',
    component: withAuthentication(ChangePassword),
    path: ROUTES.NEW_PASSWORD,
  },
  {
    id: uuid(),
    name: 'Contact',
    component: <Contact />,
    path: ROUTES.CONTACT_US,
  },
  // {
  //   id: uuid(),
  //   name: 'Tours',
  //   component: <Tours />,
  //   path: ROUTES.HOT_TOURS,
  // },
  {
    id: uuid(),
    name: 'ToursById',
    component: <ToursById />,
    path: `${ROUTES.HOT_TOURS}/:id`,
  },
  {
    id: uuid(),
    name: 'Welcome',
    component: <Welcome />,
    path: ROUTES.WELCOME,
  },
  {
    id: uuid(),
    name: 'About',
    component: <About />,
    path: ROUTES.ABOUT_US,
  },
  {
    id: uuid(),
    name: 'HowItsWork',
    component: <HowItsWork />,
    path: ROUTES.HOW_ITS_WORK,
  },
  {
    id: uuid(),
    name: 'NotFound',
    component: <NotFound />,
    path: '*',
  },
  {
    id: uuid(),
    name: 'tours/suggestion/id',
    component: <TourSuggestion />,
    path: ROUTES.TOURS_SUGGESTION_ID,
  },
];

export const PrivateRoutes = [
  {
    id: uuid(),
    name: 'Home',
    component: <Home />,
    path: ROUTES.HOME,
  },
  {
    id: uuid(),
    name: 'Settings',
    component: <Settings />,
    path: ROUTES.SETTINGS,
  },
  {
    id: uuid(),
    name: 'Questions',
    component: <Questions />,
    path: ROUTES.QUESTIONS,
  },
  {
    id: uuid(),
    name: 'Requests',
    component: <Requests />,
    path: ROUTES.REQUESTS,
  },
  {
    id: uuid(),
    name: 'Requests',
    component: <OfferItem />,
    path: ROUTES.REQUESTS_ID,
  },
  {
    id: uuid(),
    name: 'Requests',
    component: <RequestQuestions />,
    path: ROUTES.VIEW_REQUEST_ID,
  },
  {
    id: uuid(),
    name: 'Suggestions',
    component: <Suggestion />,
    path: ROUTES.SUGGESTION_ID,
  },
  {
    id: uuid(),
    name: 'offers',
    component: <RequestItem />,
    path: ROUTES.OFFER_ID,
  },
  {
    id: uuid(),
    name: 'offers',
    component: <RequestsOffer />,
    path: ROUTES.OFFERS,
  },
  {
    id: uuid(),
    name: 'ChangePasswordFrom',
    component: <PasswordEdit />,
    path: ROUTES.CHANGE_PASSWORD,
  },
  {
    id: uuid(),
    name: 'DeleteAccountForm',
    component: <DeleteAccount />,
    path: ROUTES.DELETE_ACCOUNT,
  },
];

export const AdminPrivateRoutes = [
  {
    name: 'admin/home',
    component: <AdminHome />,
    path: ROUTES.ADMIN_HOME,
  },

  {
    name: 'admin/questions',
    component: <AdminQuestions />,
    path: ROUTES.ADMIN_QUESTIONS,
  },
  {
    name: 'admin/signIn',
    component: <SignIn />,
    path: ROUTES.ADMIN_SIGN_IN,
  },
  {
    name: 'admin/requests',
    component: <AdminRequests />,
    path: ROUTES.ADMIN_REQUESTS,
  },
  {
    name: 'admin/requests/offer',
    component: <AdminOffer />,
    path: ROUTES.ADMIN_REQUESTS_OFFER,
  },
  {
    name: 'admin/requests/offer/:id',
    component: <AdminOffer />,
    path: ROUTES.ADMIN_REQUESTS_OFFER_ID,
  },
  {
    name: 'admin/packages',
    component: <AdminPackages />,
    path: ROUTES.ADMIN_PACKAGES,
  },
  {
    name: 'admin/hotOffers',
    component: <HotOffers />,
    path: ROUTES.ADMIN_HOT_OFFERS,
  },
  {
    name: 'admin/profile',
    component: <AdminProfile />,
    path: ROUTES.ADMIN_PROFILE,
  },
];
